<div class="multiselect-container" [ngClass]="{'error': error}">
  @if (label) {
    <label [for]="multiselectId" class="multiselect-label">{{ label }}</label>
  }

  <p-multiselect
    #multiselectElement
    [options]="options"
    [(ngModel)]="selectedOptions"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngClass]="[size, isDropdownOpen ? 'menu-open' : '', displayMode === 'list' ? 'display-list' : 'display-chip']"
    class="custom-multiselect"
    (onShow)="onDropdownOpen()"
    (onHide)="onDropdownClose()"
    [id]="multiselectId"
    optionLabel="label"
    optionValue="value"
    [showToggleAll]="false"
    [display]="'comma'"
    [filter]="filter"
    [filterPlaceHolder]="filterPlaceholder"
    filterBy="label"
    [appendTo]="appendTo"
    [panelStyleClass]="panelStyleClass"
  >
    <ng-template pTemplate="selectedItem" let-option>
      <span>{{ option?.label }}</span>
    </ng-template>
    <ng-template pTemplate="item" let-option>
      <span>{{ option?.label }}</span>
    </ng-template>
    <ng-template pTemplate="dropdownicon">
      <lucide-icon [name]="isDropdownOpen ? 'ChevronUp' : 'ChevronDown'" class="custom-icon"></lucide-icon>
    </ng-template>
  </p-multiselect>

  <!-- Display selected items below the input -->
  @if (selectedOptions && selectedOptions.length > 0) {
    <!-- List mode: vertical list with circles -->
    @if (displayMode === 'list') {
      <div class="selected-items-list">
        @for (value of selectedOptions; track value) {
          <div class="selected-item">
            @if (showAvatar && getOptionEmployeeId(value)) {
              <app-avatar
                [employeeId]="getOptionEmployeeId(value)!"
                [name]="getOptionLabel(value)"
                [showInfo]="false"
              ></app-avatar>
            } @else if (showIcon && getOptionIcon(value)) {
              <div class="item-icon-wrapper">
                @if (getOptionIconType(value) === 'lucide') {
                  <lucide-icon [name]="getOptionIcon(value)!" [size]="20" class="item-lucide-icon"></lucide-icon>
                } @else {
                  <img [src]="getOptionIcon(value)" class="item-icon" />
                }
              </div>
            } @else {
              <div class="item-icon-placeholder"></div>
            }
            <span class="item-label">{{ getOptionLabel(value) }}</span>
            <button
              type="button"
              class="remove-item-btn"
              (click)="removeItem(value)"
              [disabled]="disabled"
            >
              <lucide-icon name="X"></lucide-icon>
            </button>
          </div>
        }
      </div>
    }

    <!-- Chip mode: horizontal chips -->
    @if (displayMode === 'chip') {
      <div class="selected-chips-container">
        @for (value of selectedOptions; track value) {
          <app-chip
            [label]="getOptionLabel(value)"
            [removable]="!disabled"
            size="small"
            (onRemove)="removeItem(value)"
          ></app-chip>
        }
      </div>
    }
  }

  @if (error) {
    <div class="error-message">{{ errorMessage }}</div>
  }
</div>